import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: BACKEND_URL,
  withCredentials: true,
});

// Multi-site: inject the active establishment into every request so all data is
// filtered server-side by location. "all" (OWNER/MANAGER) clears the filter.
api.interceptors.request.use((config) => {
  try {
    const loc = localStorage.getItem("actipilote.activeLocation");
    if (loc && loc !== "all") {
      config.params = { ...(config.params || {}) };
      if (config.params.location_id === undefined) config.params.location_id = loc;
    }
  } catch (e) { /* localStorage unavailable */ }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
